export const conversionCategoryText = (text: string) => {
  return text.toLowerCase() === 'redirect' ? 'dynamic' : text.toLowerCase();
};
